import { Form, Col } from "react-bootstrap";
import { NumberInput } from "rsuite";

export default function HourPicker({ formData, setFormData, name }) {
    return (
        <Form.Group as={Col} controlId={`${name}-hour`} className="col-auto w-hour-picker">
            <Form.Label>Hour</Form.Label>
            <NumberInput max={23} min={0} scrollable={false} value={formData.hour} onChange={value => setFormData({ ...formData, hour: value })} />
        </Form.Group>
    );
}
